import {Box, Stack, Typography, TextField} from "@mui/material";
import {useEffect, useState} from "react";
import {useDebounce} from "../shared/hooks/useDebounce.ts";

interface TextPromptWidgetProps {
    onTextChange: (text: string) => void;
    onFocus: () => void

}

export const TextPromptWidget = ({onTextChange, onFocus}: TextPromptWidgetProps) => {
    const [prompt, setPromptValue] = useState('');
    const debouncedPrompt = useDebounce(prompt, 500);

    useEffect(() => {
        onTextChange(debouncedPrompt);
    }, [debouncedPrompt]);


    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        setPromptValue(value);
    };


    return (
        <Box sx={{padding: " 0 0 24px 0"}}>
            <Typography variant="h6" sx={{textAlign: "center", marginBottom: "16px"}}>
                Describe what you want
            </Typography>
            <Stack spacing={2}>
                <TextField
                    value={prompt}
                    onChange={handleChange}
                    placeholder="Enter your prompt"
                    fullWidth
                    multiline
                    minRows={3}
                    onFocus={onFocus}
                    InputProps={{
                        sx: {
                            borderRadius: "16px",
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            backdropFilter: 'blur(100px) saturate(200%)',
                            WebkitBackdropFilter: 'blur(100px) saturate(200%)',
                            boxShadow: '0 5px 10px rgba(0, 0, 0, 0.3)',
                            border: '1px solid rgba(255, 255, 255, 0.05)',
                            "& fieldset": {
                                borderColor: "rgba(255, 255, 255, 0.1)",
                            },
                            "&:hover fieldset": {
                                borderColor: "rgba(255, 255, 255, 0.2)",
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "#8c0046",
                            },
                        },
                    }}
                />
            </Stack>
        </Box>
    );
};
